import { InjectionToken, Type } from '@angular/core';

/**
 *
 * Das LORENZ_FORM_COMPONENT_MAPPING Token kann von Apps benutzt werden,
 * um einzelnen Elementen einer FORM eine COMPONENT zuzuordnen,
 * die dann verwendet wird, um das Element anzuzeigen.
 *
 * Die Werte müssen das Interface LorenzFormComponentMapping nutzen.
 *
 */

export interface LorenzFormComponentMapping {
	[key: string]: {
		component: Type<any>;
		payload?: any;
	};
}

export const LORENZ_FORM_COMPONENT_MAPPING = new InjectionToken<LorenzFormComponentMapping>('LORENZ_FORM_COMPONENT_MAPPING');
